
import React from "react";
import { motion } from "framer-motion";
import Terms from "../assets/termsimage.webp";

const termsData = [
  {
    title: "1. Acceptance of Terms",
    content:
      "By accessing or using our Bulk SMS platform, you agree to be bound by these Terms and Conditions. If you do not agree, you must discontinue the use of our services immediately.",
  },
  {
    title: "2. Service Overview",
    content:
      "Our Bulk SMS service enables users to send transactional, promotional, and OTP messages through a secure cloud-based platform, subject to applicable laws and regulations.",
  },
  {
    title: "3. User Responsibilities",
    content:
      "You are solely responsible for all message content sent using our platform. Messages must not be illegal, misleading, offensive, spam-related, or violate any regulatory guidelines.",
  },
  {
    title: "4. Regulatory Compliance",
    content:
      "Users must comply with all applicable telecom regulations including TRAI guidelines, DLT registration requirements, and data protection laws while using our Bulk SMS services.",
  },
  {
    title: "5. Account Security",
    content:
      "You are responsible for maintaining the confidentiality of your account credentials. Any activity performed through your account shall be deemed authorized by you.",
  },
  {
    title: "6. Message Delivery Disclaimer",
    content:
      "While we strive to maintain high delivery rates, message delivery is subject to telecom operators, network availability, recipient devices, and regulatory filters.",
  },
  {
    title: "7. Payments & Billing",
    content:
      "All payments made for SMS credits and services are non-refundable unless explicitly stated. Pricing and plans may change with prior notice.",
  },
  {
    title: "8. Suspension & Termination",
    content:
      "We reserve the right to suspend or terminate your account without notice in cases of misuse, violation of policies, or suspicious activities.",
  },
  {
    title: "9. Limitation of Liability",
    content:
      "We shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use or inability to use our Bulk SMS services.",
  },
  {
    title: "10. Changes to Terms",
    content:
      "We reserve the right to update or modify these Terms & Conditions at any time. Continued use of the platform implies acceptance of the revised terms.",
  },
];

export const Termsandconditions = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      
      {/* ================= HERO SECTION (Unchanged) ================= */}
      <div className="relative w-full h-[60vh] min-h-[400px] overflow-hidden">
        
        {/* Background Image Animation */}
        <motion.div
          className="absolute inset-0 w-full h-full"
          initial={{ scale: 1 }}
          animate={{ scale: 1.1 }}
          transition={{
            duration: 10,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
          }}
        >
          <img
            src={Terms}
            alt="Terms and Conditions"
            className="w-full h-full object-cover"
          />
        </motion.div>

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/70" />

        {/* Hero Content */}
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="text-4xl md:text-6xl font-bold text-white mb-4"
          >
            Terms &{" "}
            <span className="bg-gradient-to-r from-[#F46653] to-[#ff8c7d] bg-clip-text text-transparent">
              Conditions
            </span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-lg md:text-xl text-gray-200 max-w-2xl"
          >
            Please read these terms carefully before using our Bulk SMS services.
          </motion.p>
        </div>
      </div>

      {/* ================= TERMS CONTENT SECTION (Static - No Animations) ================= */}
      <section className="bg-white py-20 px-4">
        <div className="max-w-5xl mx-auto">
          
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              Legal Terms & Conditions
            </h2>
            <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
              These Terms & Conditions govern your access to and usage of our
              Bulk SMS messaging platform.
            </p>
          </div>

          {/* Terms List */}
          <div className="space-y-10">
            {termsData.map((item, index) => (
              <div
                key={index}
                className="border-b border-gray-200 pb-6"
              >
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {item.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};